import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string;
    fill?: string;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

export const ApplePayCard = ({ className }: PropsType): JSX.Element => (
    <SvgElement
        className={className}
        width={32}
        height={20}
        viewBox='0 0 32 20'
        fill='none'
    >
        <path
            d='M0 2C0 0.895431 0.895431 0 2 0H30C31.1046 0 32 0.895431 32 2V18C32 19.1046 31.1046 20 30 20H2C0.895431 20 0 19.1046 0 18V2Z'
            fill='white'
        />
        <path
            d='M2 0.5H30C30.8284 0.5 31.5 1.17157 31.5 2V18C31.5 18.8284 30.8284 19.5 30 19.5H2C1.17157 19.5 0.5 18.8284 0.5 18V2C0.5 1.17157 1.17157 0.5 2 0.5Z'
            stroke='#101D3A'
            strokeOpacity='0.1'
        />
        <path
            d='M23.8278 11.6772H23.845L25.0055 7.94339H26L24.2812 12.7721C23.8888 13.8844 23.4352 14.2421 22.4844 14.2421C22.4058 14.2421 22.1702 14.2334 22.1005 14.2204V13.4571C22.1702 13.4745 22.3273 13.4743 22.4058 13.4743C22.8419 13.4743 23.0775 13.2912 23.2214 12.8202C23.2214 12.8114 23.3042 12.541 23.3042 12.5366L21.6468 7.94339H22.6673L23.8278 11.6772Z'
            fill='black'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M19.4248 7.86056C20.5371 7.86058 21.2479 8.44951 21.2479 9.36987V12.5324H20.345V11.7776H20.3232C20.0572 12.2879 19.4771 12.6107 18.8752 12.6107C17.9767 12.6107 17.3484 12.0524 17.3484 11.228C17.3484 10.4254 17.9634 9.93249 19.0539 9.87137L20.3102 9.7973V9.44393C20.3102 8.93364 19.9656 8.6284 19.39 8.62836C18.8447 8.62836 18.5043 8.88997 18.4215 9.30004H17.5316C17.5839 8.47121 18.2906 7.86056 19.4248 7.86056ZM19.1805 10.5213C18.6178 10.5606 18.2994 10.8094 18.2994 11.202C18.2995 11.6032 18.6308 11.8649 19.1367 11.8649C19.7954 11.8649 20.3102 11.4111 20.3102 10.8136V10.4517L19.1805 10.5213Z'
            fill='black'
        />
        <path
            d='M10.1287 7.4074C10.3468 7.42428 10.9757 7.49141 11.3782 8.08672C11.3446 8.11221 10.6319 8.52327 10.6403 9.3874C10.6487 10.4194 11.5459 10.7636 11.5543 10.772C11.5457 10.7978 11.4117 11.2591 11.0847 11.7369C10.7996 12.1566 10.5058 12.5678 10.0362 12.5762C9.58344 12.5845 9.43237 12.3074 8.91278 12.3074C8.39276 12.3074 8.22506 12.5676 7.79726 12.5844C7.34447 12.601 7.00081 12.1392 6.71567 11.7199C6.12855 10.8723 5.68419 9.32862 6.28796 8.28799C6.58152 7.76788 7.11821 7.44079 7.69662 7.43228C8.14108 7.42414 8.55213 7.72628 8.82062 7.72628C9.08898 7.7262 9.56679 7.37393 10.1287 7.4074Z'
            fill='black'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M15.0213 6.23789C16.2426 6.23789 17.0931 7.07982 17.0931 8.30552C17.0931 9.53557 16.2252 10.3819 14.9907 10.3819H13.6386V12.5324H12.6616V6.23789H15.0213ZM13.6386 9.56182H14.7595C15.6101 9.56182 16.0944 9.10368 16.0944 8.30976C16.0943 7.51601 15.6102 7.06227 14.764 7.06223H13.6386V9.56182Z'
            fill='black'
        />
        <path
            d='M10.1329 5.75787C10.175 6.16198 10.0153 6.55767 9.7798 6.85219C9.53584 7.1384 9.14928 7.3652 8.76239 7.33164C8.71198 6.94451 8.9056 6.53268 9.12423 6.28029C9.36774 5.98556 9.78821 5.77504 10.1329 5.75787Z'
            fill='black'
        />
    </SvgElement>
);
